/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as CookiePolicyRouteRouteImport } from './routes/cookie-policy/route'
import { Route as CookiesRouteRouteImport } from './routes/cookies/route'
import { Route as ChatAccessCodeRouteImport } from './routes/chat/$accessCode'
import { Route as DeleteAccountIndexRouteImport } from './routes/delete-account/index'
import { Route as IntegrationsConnectSapConcurRouteRouteImport } from './routes/integrations/connect/sap-concur/route'
import { Route as SafetyCheckChannelIdRouteImport } from './routes/safety-check/$channel.$id'
import { Route as SafetyCheckIdIndexRouteImport } from './routes/safety-check/$id.index'
import { Route as SignupOrgIdRouteImport } from './routes/signup/org.$id'
import { Route as IntegrationsConnectSapConcurIndexRouteImport } from './routes/integrations/connect/sap-concur/index'
import { Route as IntegrationsConnectSapConcurConfirmationIndexRouteImport } from './routes/integrations/connect/sap-concur/confirmation/index'

const SignupCallbackLazyRouteImport = createFileRoute('/signup/callback')()

const CookiePolicyRouteRoute = CookiePolicyRouteRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRouteRoute = CookiesRouteRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatAccessCodeRoute = ChatAccessCodeRouteImport.update({
  id: '/chat/$accessCode',
  path: '/chat/$accessCode',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/chat/$accessCode.lazy').then((d) => d.Route),
)
const DeleteAccountIndexRoute = DeleteAccountIndexRouteImport.update({
  id: '/delete-account/',
  path: '/delete-account/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/delete-account/index.lazy').then((d) => d.Route),
)
const SignupCallbackLazyRoute = SignupCallbackLazyRouteImport.update({
  id: '/signup/callback',
  path: '/signup/callback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/signup/callback.lazy').then((d) => d.Route),
)
const IntegrationsConnectSapConcurRouteRoute =
  IntegrationsConnectSapConcurRouteRouteImport.update({
    id: '/integrations/connect/sap-concur',
    path: '/integrations/connect/sap-concur',
    getParentRoute: () => rootRouteImport,
  } as any)
const SafetyCheckChannelIdRoute = SafetyCheckChannelIdRouteImport.update({
  id: '/safety-check/$channel/$id',
  path: '/safety-check/$channel/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/safety-check/$channel.$id.lazy').then((d) => d.Route),
)
const SafetyCheckIdIndexRoute = SafetyCheckIdIndexRouteImport.update({
  id: '/safety-check/$id/',
  path: '/safety-check/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupOrgIdRoute = SignupOrgIdRouteImport.update({
  id: '/signup/org/$id',
  path: '/signup/org/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/signup/org.$id.lazy').then((d) => d.Route),
)
const IntegrationsConnectSapConcurIndexRoute =
  IntegrationsConnectSapConcurIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => IntegrationsConnectSapConcurRouteRoute,
  } as any).lazy(() =>
    import('./routes/integrations/connect/sap-concur/index.lazy').then(
      (d) => d.Route,
    ),
  )
const IntegrationsConnectSapConcurConfirmationIndexRoute =
  IntegrationsConnectSapConcurConfirmationIndexRouteImport.update({
    id: '/confirmation/',
    path: '/confirmation/',
    getParentRoute: () => IntegrationsConnectSapConcurRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/integrations/connect/sap-concur/confirmation/index.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/cookie-policy': typeof CookiePolicyRouteRoute
  '/cookies': typeof CookiesRouteRoute
  '/chat/$accessCode': typeof ChatAccessCodeRoute
  '/signup/callback': typeof SignupCallbackLazyRoute
  '/delete-account/': typeof DeleteAccountIndexRoute
  '/integrations/connect/sap-concur': typeof IntegrationsConnectSapConcurRouteRouteWithChildren
  '/safety-check/$channel/$id': typeof SafetyCheckChannelIdRoute
  '/signup/org/$id': typeof SignupOrgIdRoute
  '/safety-check/$id/': typeof SafetyCheckIdIndexRoute
  '/integrations/connect/sap-concur/': typeof IntegrationsConnectSapConcurIndexRoute
  '/integrations/connect/sap-concur/confirmation/': typeof IntegrationsConnectSapConcurConfirmationIndexRoute
}
export interface FileRoutesByTo {
  '/cookie-policy': typeof CookiePolicyRouteRoute
  '/cookies': typeof CookiesRouteRoute
  '/chat/$accessCode': typeof ChatAccessCodeRoute
  '/signup/callback': typeof SignupCallbackLazyRoute
  '/delete-account': typeof DeleteAccountIndexRoute
  '/safety-check/$channel/$id': typeof SafetyCheckChannelIdRoute
  '/signup/org/$id': typeof SignupOrgIdRoute
  '/safety-check/$id': typeof SafetyCheckIdIndexRoute
  '/integrations/connect/sap-concur': typeof IntegrationsConnectSapConcurIndexRoute
  '/integrations/connect/sap-concur/confirmation': typeof IntegrationsConnectSapConcurConfirmationIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/cookie-policy': typeof CookiePolicyRouteRoute
  '/cookies': typeof CookiesRouteRoute
  '/chat/$accessCode': typeof ChatAccessCodeRoute
  '/signup/callback': typeof SignupCallbackLazyRoute
  '/delete-account/': typeof DeleteAccountIndexRoute
  '/integrations/connect/sap-concur': typeof IntegrationsConnectSapConcurRouteRouteWithChildren
  '/safety-check/$channel/$id': typeof SafetyCheckChannelIdRoute
  '/signup/org/$id': typeof SignupOrgIdRoute
  '/safety-check/$id/': typeof SafetyCheckIdIndexRoute
  '/integrations/connect/sap-concur/': typeof IntegrationsConnectSapConcurIndexRoute
  '/integrations/connect/sap-concur/confirmation/': typeof IntegrationsConnectSapConcurConfirmationIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/cookie-policy'
    | '/cookies'
    | '/chat/$accessCode'
    | '/signup/callback'
    | '/delete-account/'
    | '/integrations/connect/sap-concur'
    | '/safety-check/$channel/$id'
    | '/signup/org/$id'
    | '/safety-check/$id/'
    | '/integrations/connect/sap-concur/'
    | '/integrations/connect/sap-concur/confirmation/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/cookie-policy'
    | '/cookies'
    | '/chat/$accessCode'
    | '/signup/callback'
    | '/delete-account'
    | '/safety-check/$channel/$id'
    | '/signup/org/$id'
    | '/safety-check/$id'
    | '/integrations/connect/sap-concur'
    | '/integrations/connect/sap-concur/confirmation'
  id:
    | '__root__'
    | '/cookie-policy'
    | '/cookies'
    | '/chat/$accessCode'
    | '/signup/callback'
    | '/delete-account/'
    | '/integrations/connect/sap-concur'
    | '/safety-check/$channel/$id'
    | '/signup/org/$id'
    | '/safety-check/$id/'
    | '/integrations/connect/sap-concur/'
    | '/integrations/connect/sap-concur/confirmation/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CookiePolicyRouteRoute: typeof CookiePolicyRouteRoute
  CookiesRouteRoute: typeof CookiesRouteRoute
  ChatAccessCodeRoute: typeof ChatAccessCodeRoute
  SignupCallbackLazyRoute: typeof SignupCallbackLazyRoute
  DeleteAccountIndexRoute: typeof DeleteAccountIndexRoute
  IntegrationsConnectSapConcurRouteRoute: typeof IntegrationsConnectSapConcurRouteRouteWithChildren
  SafetyCheckChannelIdRoute: typeof SafetyCheckChannelIdRoute
  SignupOrgIdRoute: typeof SignupOrgIdRoute
  SafetyCheckIdIndexRoute: typeof SafetyCheckIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$accessCode': {
      id: '/chat/$accessCode'
      path: '/chat/$accessCode'
      fullPath: '/chat/$accessCode'
      preLoaderRoute: typeof ChatAccessCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delete-account/': {
      id: '/delete-account/'
      path: '/delete-account'
      fullPath: '/delete-account/'
      preLoaderRoute: typeof DeleteAccountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/callback': {
      id: '/signup/callback'
      path: '/signup/callback'
      fullPath: '/signup/callback'
      preLoaderRoute: typeof SignupCallbackLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/connect/sap-concur': {
      id: '/integrations/connect/sap-concur'
      path: '/integrations/connect/sap-concur'
      fullPath: '/integrations/connect/sap-concur'
      preLoaderRoute: typeof IntegrationsConnectSapConcurRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/safety-check/$channel/$id': {
      id: '/safety-check/$channel/$id'
      path: '/safety-check/$channel/$id'
      fullPath: '/safety-check/$channel/$id'
      preLoaderRoute: typeof SafetyCheckChannelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/safety-check/$id/': {
      id: '/safety-check/$id/'
      path: '/safety-check/$id'
      fullPath: '/safety-check/$id/'
      preLoaderRoute: typeof SafetyCheckIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/org/$id': {
      id: '/signup/org/$id'
      path: '/signup/org/$id'
      fullPath: '/signup/org/$id'
      preLoaderRoute: typeof SignupOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/connect/sap-concur/': {
      id: '/integrations/connect/sap-concur/'
      path: '/'
      fullPath: '/integrations/connect/sap-concur/'
      preLoaderRoute: typeof IntegrationsConnectSapConcurIndexRouteImport
      parentRoute: typeof IntegrationsConnectSapConcurRouteRoute
    }
    '/integrations/connect/sap-concur/confirmation/': {
      id: '/integrations/connect/sap-concur/confirmation/'
      path: '/confirmation'
      fullPath: '/integrations/connect/sap-concur/confirmation/'
      preLoaderRoute: typeof IntegrationsConnectSapConcurConfirmationIndexRouteImport
      parentRoute: typeof IntegrationsConnectSapConcurRouteRoute
    }
  }
}

interface IntegrationsConnectSapConcurRouteRouteChildren {
  IntegrationsConnectSapConcurIndexRoute: typeof IntegrationsConnectSapConcurIndexRoute
  IntegrationsConnectSapConcurConfirmationIndexRoute: typeof IntegrationsConnectSapConcurConfirmationIndexRoute
}

const IntegrationsConnectSapConcurRouteRouteChildren: IntegrationsConnectSapConcurRouteRouteChildren =
  {
    IntegrationsConnectSapConcurIndexRoute:
      IntegrationsConnectSapConcurIndexRoute,
    IntegrationsConnectSapConcurConfirmationIndexRoute:
      IntegrationsConnectSapConcurConfirmationIndexRoute,
  }

const IntegrationsConnectSapConcurRouteRouteWithChildren =
  IntegrationsConnectSapConcurRouteRoute._addFileChildren(
    IntegrationsConnectSapConcurRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  CookiePolicyRouteRoute: CookiePolicyRouteRoute,
  CookiesRouteRoute: CookiesRouteRoute,
  ChatAccessCodeRoute: ChatAccessCodeRoute,
  SignupCallbackLazyRoute: SignupCallbackLazyRoute,
  DeleteAccountIndexRoute: DeleteAccountIndexRoute,
  IntegrationsConnectSapConcurRouteRoute:
    IntegrationsConnectSapConcurRouteRouteWithChildren,
  SafetyCheckChannelIdRoute: SafetyCheckChannelIdRoute,
  SignupOrgIdRoute: SignupOrgIdRoute,
  SafetyCheckIdIndexRoute: SafetyCheckIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
